import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Alert, Offcanvas, Modal, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import "../assets/MealPlanManagement.css"
import { useDispatch, useSelector } from "react-redux";
import { addMealPlanDetail, deleteMealPlanDetail, updateMealPlanDetail, fetchMealPlansForMonth } from '../redux/slice/mealPlanDetailSlice'
import { fetchMeals } from "../redux/slice/mealSlice";
import { formatDate } from "../utils/formatDate";
import { CustomDropdown } from "../components/CustomDropdownInput";
import LoadingComponent from "../components/LoadingComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowLeft, faPlus, faPenToSquare, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import NotificationToast from "../components/Notifications";
import LockDayToggle from "../components/LockDayToggle";
import { faLock } from "@fortawesome/free-solid-svg-icons";

const MealPlanManagement = () => {
  const dispatch = useDispatch()
  const today = new Date();
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [showOffcanvasMeals, setShowOffcanvasMeals] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedMealPlan, setSelectedMealPlan] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const { details, status: statusMealPlan, error: errorMealPlan } = useSelector((state) => state.mealPlanDetails);
  const { meals, status: statusMeals, error: errorMeals } = useSelector((state) => state.mealDetails);
  const [mealPlan, setMealPlan] = useState({})
  const [toast, setToast] = useState({
    message: '',
    variant: 'success',
    show: false
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    dispatch(fetchMealPlansForMonth({ 'month': currentMonth + 1, 'year': currentYear }))
  }, [dispatch, currentYear, currentMonth])


  useEffect(() => {
    if (statusMeals === 'idle') {
      dispatch(fetchMeals())
    }

  }, [dispatch, statusMeals]);

  const sortedMeals = [...meals].sort((a, b) => {
    return a.name.localeCompare(b.name, 'el', { sensitivity: 'base' });
  });

  const handleCloseMeals = () => setShowOffcanvasMeals(false);

  const handleCloseModal = () => setShowModal(false);

  const handleShowModal = (action) => {
    setModalAction(action);
    setShowModal(true);
  };

  const mealsByDate = details.reduce((acc, meal) => {
    const date = meal.date;
    if (!acc[date]) acc[date] = [];
    acc[date].push(meal);
    return acc;
  }, {});

  const handleShowMeals = (date, meals) => {
    setSelectedDate(date);
    setSelectedMealPlan(meals)
    if (meals === undefined) {
      setMealPlan({
        holiday: false,
        lock: false,
        id: null,
        date: date,
        meal_one: null,
        meal_two: null,
        meal_three: null,
        meal_one_order_limit: 200,
        meal_two_order_limit: 200,
        meal_three_order_limit: 200,
        total_meals_order_limit: 6,
      })
    } else {
      setMealPlan({
        holiday: meals[0]?.holiday,
        lock: meals[0]?.lock,
        id: meals[0]?.id,
        date: meals[0]?.date,
        meal_one: meals[0]?.meal_one,
        meal_two: meals[0]?.meal_two,
        meal_three: meals[0]?.meal_three,
        meal_one_name: meals[0]?.meal_one_name,
        meal_two_name: meals[0]?.meal_two_name,
        meal_three_name: meals[0]?.meal_three_name,
        meal_one_order_limit: meals[0]?.meal_one_order_limit,
        meal_two_order_limit: meals[0]?.meal_two_order_limit,
        meal_three_order_limit: meals[0]?.meal_three_order_limit,
        total_meals_order_limit: meals[0]?.total_meals_order_limit,
      });
    }
    setShowOffcanvasMeals(true);
  };

  const handleAddMealPlan = () => {
    const mealPlanData = {
      "holiday": mealPlan?.holiday,
      "lock": mealPlan?.lock,
      "date": mealPlan?.date,
      "meal_one": mealPlan?.meal_one,
      "meal_two": mealPlan?.meal_two,
      "meal_three": mealPlan?.meal_three,
      "meal_one_order_limit": mealPlan?.meal_one_order_limit,
      "meal_two_order_limit": mealPlan?.meal_two_order_limit,
      "meal_three_order_limit": mealPlan?.meal_three_order_limit,
      "meal_one_available": mealPlan?.meal_one_order_limit,
      "meal_two_available": mealPlan?.meal_two_order_limit,
      "meal_three_available": mealPlan?.meal_three_order_limit,
      "total_meals_order_limit": mealPlan?.total_meals_order_limit,
    }
    dispatch(addMealPlanDetail(mealPlanData)).then(response => {
      if (response?.meta?.requestStatus === 'fulfilled') {
        setToast({
          message: `Προσθήκη γευμάτων στο μενού για την ημερομηνία ${formatDate(mealPlan.date)}.`,
          variant: 'success',
          show: true
        });
      } else {

        let errorMessage = 'Υπήρξε πρόβλημα κατά την προσθήκη γευμάτων στο Μηνιαίου Μενού.';

        if (response?.error) {

          if (response?.error?.message) {
            errorMessage = response?.error?.message;
          } else if (response?.payload) {
            errorMessage = response?.payload;
          }
        }

        setToast({
          message: errorMessage,
          variant: 'danger',
          show: true
        });
      }
    }).catch((error) => {
      setToast({
        message: `Σφάλμα κατά τη διαδικασία: ${error?.message}`,
        variant: 'danger',
        show: true
      });
    });
  }
  const handleDeleteMealPlan = () => {
    dispatch(deleteMealPlanDetail(selectedMealPlan[0]?.id)).then(response => {
      if (response?.meta?.requestStatus === 'fulfilled') {
        setToast({
          message: `Διαγραφή γευμάτων άπο το μενού για την ημερομηνία ${formatDate(mealPlan.date)}.`,
          variant: 'success',
          show: true
        });
      } else {

        let errorMessage = 'Υπήρξε πρόβλημα κατά την διαγραφή γευμάτων άπο μηνιαίου μενού.';

        if (response?.error) {

          if (response?.error?.message) {
            errorMessage = response?.error?.message;
          } else if (response?.payload) {
            errorMessage = response?.payload;
          }
        }

        setToast({
          message: errorMessage,
          variant: 'danger',
          show: true
        });
      }
    }).catch((error) => {
      setToast({
        message: `Σφάλμα κατά τη διαδικασία: ${error?.message}`,
        variant: 'danger',
        show: true
      });
    });
  }
  const handleMealPlanUpdate = () => {
    const mealPlanData = {
      "holiday": mealPlan?.holiday,
      "lock": mealPlan?.lock,
      "date": mealPlan?.date,
      "meal_one": mealPlan?.meal_one,
      "meal_two": mealPlan?.meal_two,
      "meal_three": mealPlan?.meal_three,
      "meal_one_order_limit": mealPlan?.meal_one_order_limit,
      "meal_two_order_limit": mealPlan?.meal_two_order_limit,
      "meal_three_order_limit": mealPlan?.meal_three_order_limit,
      "meal_one_available": mealPlan?.meal_one_order_limit,
      "meal_two_available": mealPlan?.meal_two_order_limit,
      "meal_three_available": mealPlan?.meal_three_order_limit,
      "total_meals_order_limit": mealPlan?.total_meals_order_limit,
    }

    dispatch(updateMealPlanDetail({ mealPlanID: mealPlan?.id, mealPlanData: mealPlanData })).then(response => {
      if (response.meta.requestStatus === 'fulfilled') {
        setToast({
          message: `Ενημέρωση γευμάτων στο μηνιαίου μενού για την ημερομηνία ${formatDate(mealPlan?.date)}.`,
          variant: 'success',
          show: true
        });
      } else {

        let errorMessage = 'Υπήρξε πρόβλημα κατά την ενημέρωση γευμάτων στο μηνιαίου μενού.';

        if (response?.error) {

          if (response?.error?.message) {
            errorMessage = response?.error?.message;
          } else if (response?.payload) {
            errorMessage = response?.payload;
          }
        }

        setToast({
          message: errorMessage,
          variant: 'danger',
          show: true
        });
      }
    }).catch((error) => {
      setToast({
        message: `Σφάλμα κατά τη διαδικασία: ${error?.message}`,
        variant: 'danger',
        show: true
      });
    });
  }

  const goToNextMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear(currentYear + 1);
    } else {
      setCurrentMonth(currentMonth + 1);
    }
  };

  const goToPreviousMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear(currentYear - 1);
    } else {
      setCurrentMonth(currentMonth - 1);
    }
  };

  // Παίρνουμε την πρώτη ημέρα του μήνα
  const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();

  // Παίρνουμε τον αριθμό των ημερών του μήνα
  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

  // Παίρνουμε την τελευταία ημέρα του μήνα
  const lastDayOfMonth = new Date(currentYear, currentMonth, daysInMonth).getDay();

  // Δημιουργούμε ένα array με τις ημέρες του μήνα
  const daysArray = [...Array(daysInMonth).keys()].map((i) => i + 1);

  // Δημιουργούμε τα κελιά πριν την πρώτη ημέρα του μήνα για σωστή ευθυγράμμιση
  const emptyCellsBefore = [...Array(firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1).keys()];

  // Δημιουργούμε τα κελιά μετά την τελευταία ημέρα του μήνα για σωστή ευθυγράμμιση
  const emptyCellsAfter = [...Array(lastDayOfMonth === 0 ? 0 : 7 - lastDayOfMonth).keys()];

  // Χωρίζουμε τις ημέρες σε εβδομάδες
  const calendarRows = [];
  let weekDays = [
    ...emptyCellsBefore.map(() => null),
    ...daysArray,
    ...emptyCellsAfter.map(() => null),
  ];
  while (weekDays.length) {
    calendarRows.push(weekDays.splice(0, 7));
  }

  // Δημιουργία του μήνα ως κείμενο με βάση το currentMonth
  const monthNames = [
    "Ιανουάριος",
    "Φεβρουάριος",
    "Μάρτιος",
    "Απρίλιος",
    "Μάιος",
    "Ιούνιος",
    "Ιούλιος",
    "Αύγουστος",
    "Σεπτέμβριος",
    "Οκτώβριος",
    "Νοέμβριος",
    "Δεκέμβριος",
  ];
  const currentMonthName = monthNames[currentMonth];

  const handleSelect = (fieldName) => (selectedMeal) => {
    setMealPlan({
      ...mealPlan,
      [fieldName]: selectedMeal?.id,
      [`${fieldName}_name`]: selectedMeal?.name
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMealPlan({
      ...mealPlan,
      [name]: value
    });
  };

  const validateForm = () => {
    let valid = true;

    // Αν οποιοδήποτε πεδίο είναι άδειο, το valid γίνεται false
    if (!mealPlan?.meal_one || !mealPlan?.meal_two || !mealPlan?.meal_three) {
      valid = false;
    }

    return valid;
  };

  const handleSubmit = () => {
    if (validateForm() || mealPlan?.holiday) {
      // Αν όλα τα πεδία είναι εντάξει, προχωράμε με την υποβολή
      handleShowModal('add');
    } else {
      setToast({
        message: `Πρέπει να συμπληρώσετε τα πεδία:\n ${!mealPlan?.meal_one ? 'Πρώτο Γεύμα, ' : ''}  ${!mealPlan?.meal_two ? 'Δεύτερο Γεύμα, ' : ''} ${!mealPlan?.meal_three ? 'Τρίτο Γεύμα.' : ''}`,
        variant: 'warning',
        show: true
      });
    }
  };

  return (
    <>
      {statusMealPlan === 'loading' && <LoadingComponent />}
      {statusMeals === 'loading' && <LoadingComponent />}
      {statusMealPlan === 'failed' && <Alert variant="danger">{errorMealPlan}</Alert>}
      {statusMealPlan === 'failed' && <Alert variant="danger">{errorMeals}</Alert>}
      {(statusMealPlan === 'succeeded' && statusMeals === 'succeeded') && (
        <Container className="content-container">
          <Row className="meal-plan-header">
            <h3>Μηνιαίου Μενού</h3>
          </Row>
          <Row className="text-center mb-2">
            <Col sm={3} xs={3} className="text-left" style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
              <button className='month-item' onClick={goToPreviousMonth}>
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
            </Col>
            <Col sm={6} xs={6} className="text-center" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <h4>{`${currentMonthName} ${currentYear}`}</h4>
            </Col>
            <Col sm={3} xs={3} className="text-right" style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
              <button className='month-item' variant="light" onClick={goToNextMonth}>
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
            </Col>
          </Row>
          {!isMobile && <Row className="text-center">
            <Col sm={2} style={{ fontWeight: "600", marginRight: "0px", marginBottom: "2px", height: "50px" }}>
              ΔΕΥ
            </Col>
            <Col sm={2} style={{ fontWeight: "600", marginRight: "0px", marginBottom: "2px", height: "50px" }}>
              ΤΡΙ
            </Col>
            <Col sm={2} style={{ fontWeight: "600", marginRight: "0px", marginBottom: "2px", height: "50px" }}>
              ΤΕΤ
            </Col>
            <Col sm={2} style={{ fontWeight: "600", marginRight: "0px", marginBottom: "2px", height: "50px" }}>
              ΠΕΜ
            </Col>
            <Col sm={2} style={{ fontWeight: "600", marginRight: "0px", marginBottom: "2px", height: "50px" }}>
              ΠΑΡ
            </Col>
            <Col sm={1} style={{ fontWeight: "600", marginRight: "0px", marginBottom: "2px", height: "50px" }}>
              ΣΑΒ
            </Col>
            <Col sm={1} style={{ fontWeight: "600", marginRight: "0px", marginBottom: "2px", height: "50px" }}>
              ΚΥΡ
            </Col>
          </Row>}
          {calendarRows.map((week, index) => (
            <Row key={`${week}${index}`} className="text-right">
              {week.map((day, idx) => {
                // Δημιουργία σωστής μορφής της ημερομηνίας
                const date = `${currentYear}-${String(currentMonth + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
                const mealsForDate = mealsByDate[date];
                const isLocked = mealsForDate ? mealsForDate[0]?.lock : false
                const isHoliday = mealsForDate ? mealsForDate[0]?.holiday : false
                // const isPastDate = new Date(date) < today;
                // Προσθέτουμε +3 ημέρες
                const todayPlusThree = new Date(today);
                todayPlusThree.setDate(today.getDate() + 3);
                const isPastDatePlusThree = new Date(date) < todayPlusThree;
                const isToday =
                  day === today.getDate() &&
                  currentMonth === today.getMonth() &&
                  currentYear === today.getFullYear();


                // Έλεγχος αν η ημερομηνία ανήκει στον τρέχοντα μήνα
                const isCurrentMonth = new Date(date).getMonth() === currentMonth;
                const isWeekend = (idx === 5 || idx === 6);

                return (
                  <Col
                    md={isWeekend ? 1 : 2}
                    key={`${index}-${idx}`}
                    style={{
                      display: isMobile && !day ? "none" : "block",
                      marginBottom: "2px",
                      height: "150px",
                      borderRight: '1px solid #eeeeee',
                      // backgroundColor: isCurrentMonth ? "#c0c0c0" : 'whitesmoke',
                      backgroundColor: (isPastDatePlusThree || isLocked || isHoliday) ? "#E8ADB6" : mealsForDate ? "#c4e9da" : (isCurrentMonth || (isCurrentMonth && isWeekend)) ? "#c4e9da" : 'white',
                      color: "#333333",
                      textAlign: "end",
                      cursor: (isCurrentMonth ) ? "pointer" : "not-allowed",
                      pointerEvents: isCurrentMonth && "auto",
                      '--hover-opacity': isCurrentMonth ? "0.0" : "1.0",
                      '--hover-background-color': isCurrentMonth ? 'darkgrey' : 'whitesmoke',
                    }}
                    className={`col-hover ${isToday ? "bg-secondary text-white" : ""}`}
                    onClick={() => (isCurrentMonth) && handleShowMeals(date, mealsForDate)}
                  >
                    <div key={`name-${index}-${idx}`} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '10px', paddingBottom: '10px' }}>
                      <div className="icon-container">
                        {isCurrentMonth && !isWeekend && (
                          <FontAwesomeIcon icon={mealsForDate ? faPenToSquare : faPlus} size="lg" className="hover-icon" />
                        )}
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                        {(isLocked || isHoliday || (isPastDatePlusThree && isCurrentMonth && !mealsForDate)) && <FontAwesomeIcon style={{ color: `${isToday ? 'lightgray' : 'gray'}`, marginRight: '4px' }} icon={faLock} />}
                        {!isMobile && (day || "")}{isMobile && (formatDate(date) || "")}
                      </div>
                    </div>

                    {/* Λεπτομέρειες γευμάτων */}
                    <div style={{ textAlign: "left", fontSize: "12px", marginTop: "5px" }}>
                      {((isHoliday) &&
                        <div style={{ textAlign: 'center' }}>
                          <span><strong>Αργία</strong></span>
                        </div>
                      )
                      }
                      {!isHoliday && mealsForDate &&
                        mealsForDate.map((meal, mealIndex) => (
                          <div key={`meal-${date}-${mealIndex}`}>
                            <div>• {meal?.meal_one_name}</div>
                            <div>• {meal?.meal_two_name}</div>
                            <div>• {meal?.meal_three_name}</div>
                          </div>
                        ))}
                    </div>
                  </Col>
                );
              })}
            </Row>
          ))}

          <Offcanvas show={showOffcanvasMeals} onHide={() => setShowOffcanvasMeals(false)} placement="end">
            <Offcanvas.Header style={{ display: 'flex', flexDirection: 'column' }} closeButton>
              <Offcanvas.Title>{selectedMealPlan && selectedMealPlan.length > 0 ? 'Επεξεργασία Γευμάτων' : 'Προσθήκη Γευμάτων'}</Offcanvas.Title>
              <span>{formatDate(selectedDate)}</span>
            </Offcanvas.Header>
            <Offcanvas.Body>
              {selectedMealPlan && selectedMealPlan.length > 0 ? (
                selectedMealPlan.map((meal, mealIndex) => (
                  <div key={`meal-plan-${mealIndex}`} style={{ marginBottom: "20px" }}>

                    {/* Checkbox για Κλείδωμα Ημέρας */}
                    <LockDayToggle
                      mealPlan={mealPlan}
                      setMealPlan={setMealPlan}
                    />

                    {/* όριο συνολικών παραγγελιών ανα χρήτη*/}
                    <div>
                      <Form.Group controlId={`maxQuantityTotal`} style={{ marginTop: '10px' }}>
                        <h6 className='text-offcanvas'>Συνολικό Όριο Γευμάτων Ανά Χρήστη
                          <OverlayTrigger overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                            Ορίστε το συνολικό όριο γευμάτων για κάθε χρήστη.
                          </Tooltip>
                          }>
                            <FontAwesomeIcon icon={faCircleInfo} size="sm" color="gray" style={{ marginLeft: '5px' }} />
                          </OverlayTrigger>
                        </h6>
                        <Form.Control onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }} value={mealPlan?.total_meals_order_limit} disabled={mealPlan?.holiday} style={{ color: `${mealPlan?.holiday ? 'rgb(161,161,162)' : 'black'}` }} name="total_meals_order_limit" type="number" min="1" placeholder="Π.χ. 3" onChange={handleInputChange} />
                      </Form.Group>
                    </div>

                    {/* Πρώτο γευμα & όριο συνολικών γυεματων */}
                    <h6 className='text-offcanvas' >Πρώτο γεύμα</h6>
                    <CustomDropdown meals={sortedMeals} onSelect={handleSelect('meal_one')} selected={{ id: meal?.meal_one, name: meal?.meal_one_name }} isDisabled={mealPlan?.holiday} mealsForDisable={[mealPlan?.meal_two, mealPlan?.meal_three]} />

                    <Form.Group controlId={`maxQuantityMeal1-${mealIndex}`} style={{ marginTop: '10px' }}>
                      <h6 className='text-offcanvas'>Ημερήσιο Όριο (Πρώτο Γεύμα)
                        <OverlayTrigger overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                          Μέγιστος αριθμός διαθέσιμων πιάτων για όλους τους χρήστες (Πρώτο Γεύμα).
                        </Tooltip>
                        }>
                          <FontAwesomeIcon icon={faCircleInfo} size="sm" color="gray" style={{ marginLeft: '5px' }} />
                        </OverlayTrigger>
                      </h6>
                      <Form.Control onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }} value={mealPlan?.meal_one_order_limit} disabled={mealPlan?.holiday} style={{ color: `${mealPlan?.holiday ? 'rgb(161,161,162)' : 'black'}` }} name="meal_one_order_limit" type="number" min="1" placeholder="Π.χ. 3" onChange={handleInputChange} />
                    </Form.Group>

                    {/* Δευτερο γευμα & όριο συνολικών γυεματων */}
                    <h6 className='text-offcanvas' >Δεύτερο γεύμα</h6>
                    <CustomDropdown meals={sortedMeals} onSelect={handleSelect('meal_two')} selected={{ id: meal?.meal_two, name: meal?.meal_two_name }} isDisabled={mealPlan?.holiday} mealsForDisable={[mealPlan?.meal_one, mealPlan?.meal_three]} />

                    <Form.Group controlId={`maxQuantityMeal2-${mealIndex}`} style={{ marginTop: '10px' }}>
                      <h6 className='text-offcanvas'>Ημερήσιο Όριο (Δεύτερο Γεύμα)
                        <OverlayTrigger overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                          Μέγιστος αριθμός διαθέσιμων πιάτων για όλους τους χρήστες (Δεύτερο Γεύμα).
                        </Tooltip>
                        }>
                          <FontAwesomeIcon icon={faCircleInfo} size="sm" color="gray" style={{ marginLeft: '5px' }} />
                        </OverlayTrigger>
                      </h6>
                      <Form.Control onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }} value={mealPlan?.meal_two_order_limit} disabled={mealPlan?.holiday} style={{ color: `${mealPlan?.holiday ? 'rgb(161,161,162)' : 'black'}` }} name='meal_two_order_limit' type="number" min="1" placeholder="Π.χ. 3" onChange={handleInputChange} />
                    </Form.Group>

                    {/* τρίτο γευμα & όριο συνολικών γυεματων */}
                    <h6 className='text-offcanvas' >Τρίτο γεύμα</h6>
                    <CustomDropdown meals={sortedMeals} onSelect={handleSelect('meal_three')} selected={{ id: meal?.meal_three, name: meal?.meal_three_name }} isDisabled={mealPlan?.holiday} mealsForDisable={[mealPlan?.meal_two, mealPlan?.meal_one]} />

                    <Form.Group controlId={`maxQuantityMeal3-${mealIndex}`} style={{ marginTop: '10px' }}>
                      <h6 className='text-offcanvas'>Ημερήσιο Όριο (Τρίτο Γεύμα)
                        <OverlayTrigger overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                          Μέγιστος αριθμός διαθέσιμων πιάτων για όλους τους χρήστες (Τρίτο Γεύμα).
                        </Tooltip>
                        }>
                          <FontAwesomeIcon icon={faCircleInfo} size="sm" color="gray" style={{ marginLeft: '5px' }} />
                        </OverlayTrigger>
                      </h6>
                      <Form.Control onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }} value={mealPlan?.meal_three_order_limit} disabled={mealPlan?.holiday} style={{ color: `${mealPlan?.holiday ? 'rgb(161,161,162)' : 'black'}` }} name="meal_three_order_limit" type="number" min="1" placeholder="Π.χ. 3" onChange={handleInputChange} />
                    </Form.Group>


                    <Button variant="success" onClick={() => handleShowModal('update')} style={{ marginRight: '10px', paddingLeft: '20px', paddingRight: '20px' }}>
                      <span style={{ fontWeight: 700 }}>Ενημέρωση</span>
                    </Button>
                    <Button variant="danger" onClick={() => handleShowModal('delete')} style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                      <span style={{ fontWeight: 700 }}>Διαγραφή</span>
                    </Button>
                  </div>
                ))
              ) : (
                <div key={`meal-plan`} style={{ marginBottom: "20px" }}>
                  <LockDayToggle
                    mealPlan={mealPlan}
                    setMealPlan={setMealPlan}
                  />
                  <div>
                    <Form.Group controlId={`maxQuantityTotal`} style={{ marginTop: '10px' }}>
                      <h6 className='text-offcanvas'>Συνολικό Όριο Γευμάτων Ανά Χρήστη
                        <OverlayTrigger overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                          Ορίστε το συνολικό όριο γευμάτων για κάθε χρήστη.
                        </Tooltip>
                        }>
                          <FontAwesomeIcon icon={faCircleInfo} size="sm" color="gray" style={{ marginLeft: '5px' }} />
                        </OverlayTrigger>
                      </h6>
                      <Form.Control onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }} value={mealPlan?.total_meals_order_limit} disabled={mealPlan?.holiday} style={{ color: `${mealPlan?.holiday ? 'rgb(161,161,162)' : 'black'}` }} name="total_meals_order_limit" type="number" min="1" placeholder="Π.χ. 3" onChange={handleInputChange} />
                    </Form.Group>
                  </div>

                  {/* πρωτο γευμα & όριο συνολικών γυεματων */}
                  <h6 className='text-offcanvas' >Πρώτο γεύμα</h6>
                  <CustomDropdown meals={sortedMeals} onSelect={handleSelect('meal_one')} selected={null} isDisabled={mealPlan?.holiday} mealsForDisable={[mealPlan?.meal_two, mealPlan?.meal_three]} />
                  <Form.Group controlId={`maxQuantityMeal1`} style={{ marginTop: '10px' }}>
                    <h6 className='text-offcanvas'>Ημερήσιο Όριο (Πρώτο Γεύμα)
                      <OverlayTrigger overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                        Μέγιστος αριθμός διαθέσιμων πιάτων για όλους τους χρήστες (Πρώτο Γεύμα).
                      </Tooltip>
                      }>
                        <FontAwesomeIcon icon={faCircleInfo} size="sm" color="gray" style={{ marginLeft: '5px' }} />
                      </OverlayTrigger>
                    </h6>
                    <Form.Control onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }} value={mealPlan?.meal_one_order_limit} disabled={mealPlan?.holiday} style={{ color: `${mealPlan?.holiday ? 'rgb(161,161,162)' : 'black'}` }} name="meal_one_order_limit" type="number" min="1" placeholder="Π.χ. 3" onChange={handleInputChange} />
                  </Form.Group>

                  {/* δευτερο γευμα & όριο συνολικών γυεματων */}
                  <h6 className='text-offcanvas' >Δεύτερο γεύμα</h6>
                  <CustomDropdown meals={sortedMeals} onSelect={handleSelect('meal_two')} selected={null} isDisabled={mealPlan?.holiday} mealsForDisable={[mealPlan?.meal_one, mealPlan?.meal_three]} />
                  <Form.Group controlId={`maxQuantityMeal2`} style={{ marginTop: '10px' }}>
                    <h6 className='text-offcanvas'>Ημερήσιο Όριο (Δεύτερο Γεύμα)
                      <OverlayTrigger overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                        Μέγιστος αριθμός διαθέσιμων πιάτων για όλους τους χρήστες (Δεύτερο Γεύμα)
                      </Tooltip>
                      }>
                        <FontAwesomeIcon icon={faCircleInfo} size="sm" color="gray" style={{ marginLeft: '5px' }} />
                      </OverlayTrigger>
                    </h6>
                    <Form.Control onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }} value={mealPlan?.meal_two_order_limit} disabled={mealPlan?.holiday} style={{ color: `${mealPlan?.holiday ? 'rgb(161,161,162)' : 'black'}` }} name='meal_two_order_limit' type="number" min="1" placeholder="Π.χ. 3" onChange={handleInputChange} />
                  </Form.Group>


                  {/* τρίτο γευμα & όριο συνολικών γυεματων */}
                  <h6 className='text-offcanvas' >Τρίτο γεύμα</h6>
                  <CustomDropdown meals={sortedMeals} onSelect={handleSelect('meal_three')} selected={null} isDisabled={mealPlan?.holiday} mealsForDisable={[mealPlan?.meal_two, mealPlan?.meal_one]} />

                  <Form.Group controlId={`maxQuantityMeal3`} style={{ marginTop: '10px' }}>
                    <h6 className='text-offcanvas'>Ημερήσιο Όριο (Τρίτο Γεύμα)
                      <OverlayTrigger overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                        Μέγιστος αριθμός διαθέσιμων πιάτων για όλους τους χρήστες (Τρίτο Γεύμα).
                      </Tooltip>
                      }>
                        <FontAwesomeIcon icon={faCircleInfo} size="sm" color="gray" style={{ marginLeft: '5px' }} />
                      </OverlayTrigger>
                    </h6>
                    <Form.Control onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }} value={mealPlan?.meal_three_order_limit} disabled={mealPlan?.holiday} style={{ color: `${mealPlan?.holiday ? 'rgb(161,161,162)' : 'black'}` }} name="meal_three_order_limit" type="number" min="1" placeholder="Π.χ. 3" onChange={handleInputChange} />
                  </Form.Group>

                  <Button variant="success" onClick={() => handleSubmit()} style={{ marginRight: '10px', paddingLeft: '20px', paddingRight: '20px' }}>
                    <span style={{ fontWeight: 700 }}>Προσθήκη</span>
                  </Button>
                </div>
              )}
            </Offcanvas.Body>
          </Offcanvas>

          <Modal
            show={showModal}
            onHide={handleCloseModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {modalAction === "delete" && "Διαγραφή Προγράμματος"}
                {modalAction === "update" && "Ενημέρωση Προγράμματος"}
                {modalAction === "add" && "Προσθήκη Προγράμματος"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Είστε σίγουροι ότι θέλετε να {modalAction === "delete" ? "διαγράψετε" : modalAction === "update" ? "ενημερώσετε" : "προσθέσετε"} το πρόγραμμα γεύματος με ημερομηνία {mealPlan?.date} {mealPlan?.holiday && <span style={{ fontWeight: 700 }}>σε αργία</span>};
              <br />{!mealPlan?.holiday && <span style={{ fontWeight: 700 }}>-{mealPlan?.meal_one_name}</span>}
              <br />{!mealPlan?.holiday && <span style={{ fontWeight: 700 }}>-{mealPlan?.meal_two_name}</span>}
              <br />{!mealPlan?.holiday && <span style={{ fontWeight: 700 }}>-{mealPlan?.meal_three_name}</span>}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" className="modal-btn" onClick={handleCloseModal}><strong>Όχι</strong></Button>
              <Button variant="primary" className="modal-btn" onClick={() => {
                if (modalAction === "delete") {
                  handleDeleteMealPlan()
                } else if (modalAction === "update") {
                  handleMealPlanUpdate()
                } else if (modalAction === "add") {
                  handleAddMealPlan()
                }
                handleCloseModal();
                handleCloseMeals();
              }}>
                <strong>Ναι</strong>
              </Button>
            </Modal.Footer>
          </Modal>
          {/* Notification Toast */}
          <NotificationToast
            message={toast?.message}
            variant={toast?.variant}
            show={toast?.show}
            onClose={() => setToast({ ...toast, show: false })}
          />

        </Container>)}
    </>
  );
};

export default MealPlanManagement;
